export function calculateMonthlyMortgage(
  price = 80000,
  downPaymentPercent = 20,
  interestRate = 6.5,
  loanYears = 30,
  annualTaxPercent = 0.1,      // fraction of price per year, e.g., 0.012 = 1.2%
  monthlyInsurancePercent = 0.001 // fraction of price per month, e.g., 0.001
) {
  if (!price || !loanYears) if (!loanYears) {
    return {
      principalInterest: 0,
      taxes: 0,
      insurance: 0,
      totalMonthly: 0,
      loanAmount: Math.round(price * (1 - downPaymentPercent / 100) * 100) / 100,
      downPayment: Math.round(price * (downPaymentPercent / 100)),
    };
  };

  const loanAmount = price * (1 - downPaymentPercent / 100);
  const monthlyRate = interestRate / 100 / 12;
  const totalMonths = loanYears * 12;

  let principalInterest;

  if (monthlyRate === 0) {
    principalInterest = loanAmount / totalMonths;
  } else {
    principalInterest =
      loanAmount *
      (monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) /
      (Math.pow(1 + monthlyRate, totalMonths) - 1);
  }

  // Taxes per month as % of price
  const monthlyTaxes = (price * annualTaxPercent) / 12;

  // Insurance per month as % of price
  const monthlyInsurance = price * monthlyInsurancePercent;

  const totalMonthly = principalInterest + monthlyTaxes + monthlyInsurance;

  return {
    principalInterest: Math.round(principalInterest * 100) / 100,
    taxes: Math.round(monthlyTaxes * 100) / 100,
    insurance: Math.round(monthlyInsurance * 100) / 100,
    totalMonthly: Math.round(totalMonthly * 100) / 100,
    loanAmount: Math.round(loanAmount * 100) / 100,
    downPayment: Math.round(price * (downPaymentPercent / 100))
  };
}
